export default "__VITE_ASSET__5_bUR2_P__"